import messages from './messages';

export const investStats = [
	{
		heading: messages.item1Heading,
		number: messages.item1Stat,
		description: messages.item1Description,
	},
	{
		heading: messages.item2Heading,
		number: messages.item2Stat,
		description: messages.item2Description,
	},
	{
		heading: messages.item3Heading,
		number: messages.item3Stat,
		description: messages.item3Description,
	},
];
